import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SUPPORTED_CURRENCIES, normalizeCurrency } from "@/lib/currency";

/**
 * CurrencySelect — small ISO 4217 dropdown paired with CurrencyInput anywhere
 * a financial value is edited. Fixed width so it lines up with money inputs.
 */
export default function CurrencySelect({ value, onChange, className = "" }) {
  const v = normalizeCurrency(value);
  return (
    <Select value={v} onValueChange={onChange}>
      <SelectTrigger className={`h-9 w-[90px] bg-white/5 border-white/10 text-sm ${className}`} data-testid="currency-select">
        <SelectValue/>
      </SelectTrigger>
      <SelectContent className="bg-[#151A23] border-white/10 text-white max-h-72">
        {SUPPORTED_CURRENCIES.map((c) => (
          <SelectItem key={c} value={c}>{c}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
